// Quantity Button Functionality
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[id^="minus-"], [id^="plus-"]').forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      var container = this.closest('.quantity-box');
      if (!container) return;
      
      var input = container.querySelector('.quantity-input');
      if (!input) return;
      
      var currentValue = parseInt(input.value) || 0;
      var min = parseInt(input.getAttribute('min')) || 0;
      var max = parseInt(input.getAttribute('max')) || Infinity;
      var step = parseInt(input.getAttribute('step')) || 1;
      
      if (this.id && this.id.includes('minus')) {
        var newValue = Math.max(min, currentValue - step);
      } else {
        var newValue = Math.min(max, currentValue + step);
      }
      
      input.value = newValue;
      
      // Trigger change event for Shopify
      var event = new Event('change', { bubbles: true });
      input.dispatchEvent(event);
    });
  });
});
// pickup-demo.js
(function() {
  'use strict';

  // Pickup Demo Section - Filter + Load More Functionality
  function initPickupDemo() {
    var filterBtns = document.querySelectorAll('#pickup-demo-section .filter-btn');
    var videoGrid = document.getElementById('video-grid');
    var loadMoreBtn = document.getElementById('load-more-btn');
    
    if (!videoGrid) return;
    
    // Get all video cards
    var allVideoCards = videoGrid.querySelectorAll('.video-card');
    
    // Store current filter
    var currentFilter = 'all';
    
    // Get initial load values from data attributes
    var initialLoad = parseInt(videoGrid.dataset.initialLoad) || 6;
    var loadMoreCount = parseInt(videoGrid.dataset.loadMoreCount) || 6;
    var totalVideos = parseInt(videoGrid.dataset.totalVideos) || 0;
    
    // Store load more state per filter
    var loadState = {
      'all': {
        visible: initialLoad,
        total: allVideoCards.length,
        loadedAll: false
      }
    };
    
    // Initialize load state for each category
    filterBtns.forEach(function(btn) {
      var handle = btn.dataset.filter;
      if (handle && handle !== 'all') {
        loadState[handle] = {
          visible: initialLoad,
          total: 0,
          loadedAll: false
        };
      }
    });
    
    // Count videos per category
    allVideoCards.forEach(function(card) {
      var category = card.dataset.category;
      if (category && loadState[category]) {
        loadState[category].total++;
      }
    });
    
    // Update load state for 'all'
    loadState['all'].total = allVideoCards.length;
    
    // Category filter functionality
    if (filterBtns.length) {
      filterBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Update active button
          filterBtns.forEach(function(b) {
            b.classList.remove('active');
            b.classList.add('btn-secondary');
          });
          this.classList.add('active');
          this.classList.remove('btn-secondary');
          
          currentFilter = this.dataset.filter;
          
          // Reset visibility based on filter
          filterVideos(currentFilter);
        });
      });
    }
    
    // Filter videos function
    function filterVideos(filterValue) {
      var visibleCount = 0;
      
      allVideoCards.forEach(function(card) {
        var cardCategory = card.dataset.category;
        var shouldShow = false;
        
        if (filterValue === 'all') {
          // Show videos based on load state for 'all'
          var index = parseInt(card.dataset.videoIndex) || 0;
          var visibleLimit = loadState['all'].visible || initialLoad;
          shouldShow = (index < visibleLimit);
        } else {
          // Show videos from selected category based on load state
          if (cardCategory === filterValue) {
            var catIndex = 0;
            allVideoCards.forEach(function(c) {
              if (c.dataset.category === filterValue && c === card) {
                // This is the card
              }
              if (c.dataset.category === filterValue && c !== card) {
                catIndex++;
              }
            });
            shouldShow = (catIndex < (loadState[filterValue]?.visible || initialLoad));
          }
        }
        
        if (shouldShow) {
          card.style.display = 'block';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });
      
      // Update load more button
      updateLoadMoreButton(filterValue);
      
      // Handle no videos message
      if (visibleCount === 0) {
        var noVideosMsg = document.getElementById('no-videos-msg');
        if (!noVideosMsg) {
          var msg = document.createElement('p');
          msg.id = 'no-videos-msg';
          msg.className = 'no-videos';
          msg.textContent = 'No videos found in this category.';
          msg.style.cssText = 'text-align: center; padding: 40px 0; color: #999; grid-column: 1 / -1;';
          videoGrid.appendChild(msg);
        }
      } else {
        var existingMsg = document.getElementById('no-videos-msg');
        if (existingMsg) existingMsg.remove();
      }
    }
    
    // Update load more button
    function updateLoadMoreButton(filterValue) {
      if (!loadMoreBtn) return;
      
      var state = loadState[filterValue];
      if (!state) return;
      
      var visible = state.visible || initialLoad;
      var total = state.total || 0;
      
      if (visible >= total) {
        loadMoreBtn.style.display = 'none';
        state.loadedAll = true;
      } else {
        loadMoreBtn.style.display = 'inline-flex';
        state.loadedAll = false;
      }
      
      // Keep button text simple
      var btnText = loadMoreBtn.querySelector('.btn-text');
      if (btnText) {
        btnText.textContent = 'Load More Videos';
      }
    }
    
    // Load more functionality
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        var state = loadState[currentFilter];
        if (!state || state.loadedAll) return;
        
        // Show loading state
        this.classList.add('loading');
        var btnText = this.querySelector('.btn-text');
        var btnLoader = this.querySelector('.btn-loader');
        if (btnText) btnText.style.display = 'none';
        if (btnLoader) btnLoader.style.display = 'inline-flex';
        
        // Simulate loading delay for smooth UX
        setTimeout(function() {
          // Load more videos
          var loadCount = loadMoreCount;
          state.visible = Math.min(state.visible + loadCount, state.total);
          
          // Re-filter with updated state
          filterVideos(currentFilter);
          
          // Hide loading state
          loadMoreBtn.classList.remove('loading');
          if (btnText) btnText.style.display = 'inline';
          if (btnLoader) btnLoader.style.display = 'none';
          
        }, 500);
      });
    }
    
    // Trigger initial filter (All Videos)
    var allBtn = document.querySelector('#pickup-demo-section .filter-btn[data-filter="all"]');
    if (allBtn) {
      setTimeout(function() {
        allBtn.click();
      }, 100);
    }
  }

  // Initialize Fancybox
  function initFancybox() {
    if (typeof Fancybox !== 'undefined') {
      Fancybox.bind('[data-fancybox="pickup-demo-gallery"]', {
        infinite: false,
        Video: {
          autoPlay: true
        },
        iframe: {
          preload: false
        }
      });
    }
  }

  // Initialize when DOM is ready
  function init() {
    initPickupDemo();
    initFancybox();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();